import React, { useState } from 'react';

import './nav.css';
import { MdOutlineEmail } from 'react-icons/md';
import { RiMessengerLine } from 'react-icons/ri';
import { BsWhatsapp } from 'react-icons/bs';
import { Link } from 'react-router-dom';

const Nav = ({ show, setShow }) => {
  const [activeNav, setActiveNav] = useState('/');
  // e.preventDefaults()

  return (
    <div className='cata'>
      <div className="jc">
        <div>
          <div id="arrleft" show={show}>
            {show}
          </div>
        </div>
        <div className="codee">
          <h1 data-shadow="JustCode!">JustCode!</h1>
          <br />
          {/* <small className="text-light onlinea">online-classes</small> */}
          <div id="bl">
            <span className="tela">online-classes</span>
          </div>

          {/* <sub className="nbspc">&nbsp; online-classes</sub> */}
        </div>
        <div className="contacts">
          <a
            href="mailto:samuelonwodi@yahoo.com"
            target="_blank"
            rel="noreferrer"
          >
            <MdOutlineEmail />
          </a>
          <a
            className="remove"
            href="http://m.me/profile.php?id=100070069762030"
            target="_blank"
            rel="noreferrer"
          >
            <RiMessengerLine />
          </a>
          <a
            href="https://wa.me/2348130757003?text=Hi ,I want to learn."
            target="_blank"
            rel="noreferrer"
          >
            <BsWhatsapp />
          </a>
        </div>
      </div>
      <div className="navi mt-4">
        <ul className="nav justify-content-center">
          <li className="nav-item">
            <nav>
              <Link
                to="/"
                onClick={() => setActiveNav('/')}
                className={activeNav === '/' ? 'links' : 'nlinks'}
                title="Home"
              >
                Home
              </Link>
            </nav>
          </li>
          <li className="nav-item">
            {/* <nav> */}
              <Link
                to="/viewcourses"
                onClick={() => setActiveNav('/viewcourses')}
                className={activeNav === '/viewcourses' ? 'links' : 'nlinks'}
                title="Library"
              >
                Library
              </Link>
            {/* </nav> */}
          </li>
          <li className="nav-itemn">
            {/* <nav> */}
              <Link
                to="/testimonials"
                onClick={() => setActiveNav('/testimonies')}
                className={activeNav === '/testimonies' ? 'links' : 'nlinks'}
                title="testimonials"
              >
                Testimonials
              </Link>
            {/* </nav> */}
          </li>
          
        </ul>
      </div>
    </div>
  );
};

export default Nav;
